import { defineStore } from 'pinia';

const useLoaderStore = defineStore('loader', {
    state: () => ({
        isLoading: false
    }),
    actions: {
        showLoader() {
            this.isLoading = true;
        },

        hideLoader() {
            this.isLoading = false;
        }
    }
});

export default useLoaderStore;
